import { useContext, useEffect, useState } from "react";
import { SelectedServiceContext } from "@context/ISelectedContext";
import { ESimCardStatus } from "../interface/ISimCardRequest";
import { getSimCardsRequestRoute } from "@api-routes/eirCustomersFacade";
import { getResponseToState, ISimCardRequestResponse } from "../mappers/getSimCardRequestMapper";
import { useFetch } from "@common/hook/useFetch";

export interface ISimSwap {
    errorCode?: ESimCardStatus;
}

export const useSimCardsRequests = (): ISimSwap => {
    const { selectedService } = useContext(SelectedServiceContext);
    const [, { get }] = useFetch();
    const [simSwap, setSimSwap] = useState<ISimSwap>({});

    useEffect(() => {
        if (selectedService) {
            const searchParams = new URLSearchParams();

            searchParams.set("serviceId", selectedService.id.toString());

            get<ISimCardRequestResponse[]>(getSimCardsRequestRoute(searchParams.toString())).then(
                (simSwapRequestListResponse) => {
                    const simSwapRequestList = getResponseToState(simSwapRequestListResponse);

                    const simSwapRequestWithError = simSwapRequestList?.find((simSwapRequest) => {
                        if (simSwapRequest.status) {
                            return [ESimCardStatus.IN_VALIDATION, ESimCardStatus.ONGOING].includes(
                                simSwapRequest.status
                            );
                        }

                        return false;
                    });

                    if (simSwapRequestWithError) {
                        setSimSwap({
                            errorCode: simSwapRequestWithError.status,
                        });
                    }
                }
            );
        }
    }, [selectedService, get, setSimSwap]);

    return simSwap;
};
